<template>
  <div class="page-title">
    <span>ATRVASA</span>
  </div>
</template>

<script>
  import n from '../../assets/images/fav.png'

  export default {
    name: "Index",

    data() {
      return {
        image: n
      };
    },

    methods: {
      initialize() {
      },
    },

    beforeRouteEnter(to, from, next) {
      next(vm => vm.initialize());
    },
    beforeRouteUpdate(to, from, next) {
      this.initialize();
      next();
    }
  };
</script>

<style scoped>
  .page-title {
    text-align: center;
    /*background-color: #ebebeb;*/
    /*width: 300px;*/
    /*height: 450px;*/
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 200px;
  }

  .title-page p {
  }

</style>
